module.exports = __webpack_public_path__ + "media/images/lb/688-150454cdad4686116bc98e6eecb00225.svg";